module.exports = __webpack_public_path__ + "static/media/message-square.493b4b6f.svg";